import { render, staticRenderFns } from "./QCTablePage.vue?vue&type=template&id=7fbc10be&scoped=true&"
import script from "./QCTablePage.vue?vue&type=script&lang=js&"
export * from "./QCTablePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbc10be",
  null
  
)

export default component.exports